import React from 'react'
import Clipboard from 'react-clipboard.js'

import Button from './Button'

const CopyButton = Button.withComponent(Clipboard)

type Props = {
  dataClipboardTarget: string
} & React.ComponentProps<typeof Button>

const CopyToClipboardButton: React.FC<Props> = ({
  children,
  dataClipboardTarget,
  ...props
}) => {
  return (
    <CopyButton
      data-clipboard-target={dataClipboardTarget}
      type="button"
      uppercase={false}
      {...props}
    >
      {children || 'Copy'}
    </CopyButton>
  )
}

export default CopyToClipboardButton
